import React from 'react';

export const FlagMXIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 400" // Standard 7:4 ratio
    {...props}
  >
    <rect width="700" height="400" fill="#FFFFFF" rx="2"/> {/* White field (center) */}
    <rect width="233.33" height="400" fill="#006847" /> {/* Green stripe */}
    <rect x="466.67" width="233.33" height="400" fill="#CE1126" /> {/* Red stripe */}
    {/* Simplified Coat of Arms */}
    <g transform="translate(350 200) scale(1.2)">
      {/* Eagle body (brown) */}
      <path d="M0 -40 Q5 -30 10 -40 Q20 -20 15 0 L5 30 Q0 40 -5 30 L-15 0 Q-20 -20 -10 -40 Q-5 -30 0 -40 Z" fill="#654321"/>
      {/* Eagle head (white/yellow) */}
      <circle cx="-12" cy="-35" r="8" fill="#FFFADA"/>
      <path d="M-18 -38 L-25 -35 L-15 -30 Z" fill="#FFBF00"/> {/* Beak */}
       {/* Snake (green) */}
      <path d="M-5 -10 C0 -20 10 -15 15 -5 S20 15 10 20" stroke="#008000" strokeWidth="6" fill="none" strokeLinecap="round"/>
      {/* Prickly Pear Cactus (green simplified base) */}
      <rect x="-25" y="30" width="50" height="15" fill="#228B22" rx="3"/>
      <circle cx="-15" cy="25" r="10" fill="#228B22" />
      <circle cx="15" cy="25" r="10" fill="#228B22" />
    </g>
  </svg>
);